import { useToaster } from '@innovationdepartment/proxima-ui';
import { useProximaSDK, useShowSpinner } from 'hooks';
import { useState } from 'react';
import { useBrandStore } from 'stores';
import BrandIsManagedView from './BrandIsManaged.View';

const BrandIsManaged = () => {
  const { updateBrandStore, brand } = useBrandStore();
  const brandsApi = useProximaSDK('BrandsApi');
  const brandId = brand?.brandId;
  const [isManaged, setIsManaged] = useState(brand?.isManaged);
  const [loading, setLoading] = useState(false);
  const { showToaster } = useToaster();

  useShowSpinner({ show: loading });

  const onChange = async (value: boolean) => {
    if (!brandId) return;
    setLoading(true);

    await brandsApi.updateBrand({
      brandId,
      updateBrandRequest: {
        isManaged: value
      }
    });

    setIsManaged(value);

    await new Promise(resolve => setTimeout(resolve, 2000)); // Delay to allow UI to update

    const response = await brandsApi.getBrand({ brandId });

    showToaster({
      message: value ? 'Brand is now managed.' : 'Brand has been removed from management.',
      variant: value ? 'success' : 'warning'
    });

    updateBrandStore(response.data);
    setIsManaged(value);
    setLoading(false);
  };

  return (
    <BrandIsManagedView isManaged={isManaged} onChange={(value: boolean) => onChange(value)} />
  );
};

export default BrandIsManaged;
